import { createContext, useContext, useEffect, useState } from "react";

const ZipContext = createContext(null);

export const ZipProvider = ({ children }) => {
  const [zip, setZip] = useState(() => {
    try {
      return localStorage.getItem("couponer_zip") || "";
    } catch {
      return "";
    }
  });

  const [askOpen, setAskOpen] = useState(false);

  useEffect(() => {
    try {
      if (zip) localStorage.setItem("couponer_zip", zip);
      else localStorage.removeItem("couponer_zip");
    } catch {}
  }, [zip]);

  return (
    <ZipContext.Provider value={{ zip, setZip, askOpen, setAskOpen }}>
      {children}
    </ZipContext.Provider>
  );
};

export const useZip = () => {
  const ctx = useContext(ZipContext);
  if (!ctx) throw new Error("useZip must be used within ZipProvider");
  return ctx;
};
